import { render, staticRenderFns } from "./ModalContentMemberRemove.vue?vue&type=template&id=3803739f&scoped=true&"
import script from "./ModalContentMemberRemove.vue?vue&type=script&lang=js&"
export * from "./ModalContentMemberRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803739f",
  null
  
)

export default component.exports